import { breakpoint, Breakpoint } from "@otto-ec/global-breakpoint";

// Export breakpoint functionality to global namespace.
window.o_global = window.o_global || {};

window.o_global.breakpoint = window.o_global.breakpoint || breakpoint();
window.o_global.breakpointClass = window.o_global.breakpointClass || Breakpoint;

window.o_global.device = window.o_global.device || {};
window.o_global.device.breakpoint = window.o_global.device.breakpoint || window.o_global.breakpoint;
